import React from "react";
import { useTranslation } from "react-i18next";

const Loader = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar"; // Check if Arabic (RTL)

  return (
    <div className="loader">
      <style>{`
        .loader {
          width: 100px;
          display: grid;
          background: radial-gradient(farthest-side, #fff 98%, #0000) center/30px 100% no-repeat;
          --mask: 
            radial-gradient(12px at ${isRTL ? "right" : "left"} 15px top 50%, #5507CF 95%, #000),
            radial-gradient(12px at center, #0000 95%, #000),
            radial-gradient(12px at ${isRTL ? "left" : "right"} 15px top 50%, #5507CF 95%, #000);
          -webkit-mask: var(--mask);
                  mask: var(--mask);
          -webkit-mask-composite: source-in;
                  mask-composite: intersect;
          animation: l2 1s infinite alternate;
          direction: ${isRTL ? "rtl" : "ltr"}; /* Set direction based on language */
        }

        .loader:before,
        .loader:after {
          content: "";
          grid-area: 1/1;
          height: 30px;
          aspect-ratio: 1;
          background: #5507CF;
          border-radius: 50%;
        }

        .loader:after {
          margin-${isRTL ? "right" : "left"}: auto; /* Flip margin for RTL */
        }

        @keyframes l2 {
          to {
            width: 50px;
          }
        }
      `}</style>
    </div>
  );
};

export default Loader;